import {
  formatEventDateLabel,
  formatEventTimeLabel,
  normalizeEventRecord,
} from "./eventViewModel";
import { getEventMediaKind } from "./eventMedia";
import { eventCanonicalUrl } from "./eventRoutes";
import { PUBLIC_ORIGIN } from "./CanonicalUrl";

const DEFAULT_SHARE_IMAGE = `${PUBLIC_ORIGIN}/logo.png`;

function tidyText(value = "") {
  return String(value).replace(/\s+/g, " ").trim();
}

function truncate(value, maximumLength) {
  const text = tidyText(value);
  if (text.length <= maximumLength) return text;
  return `${text.slice(0, maximumLength - 1).trimEnd()}…`;
}

function eventLocationText(item) {
  const postcode = tidyText(item.postcode);
  const address = tidyText(item.address);
  const comparable = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, "");
  const postcodeAlreadyIncluded = postcode
    && comparable(address).includes(comparable(postcode));
  return [
    item.venueName,
    address,
    postcodeAlreadyIncluded ? "" : postcode,
  ]
    .filter(Boolean)
    .join(", ");
}

export function eventShareText(event = {}) {
  const item = normalizeEventRecord(event);
  const date = formatEventDateLabel(item);
  const time = formatEventTimeLabel(item);
  const location = eventLocationText(item);

  return [
    item.title,
    [date, time].filter(Boolean).join(" · "),
    location,
  ]
    .filter(Boolean)
    .join(" — ");
}

export function whatsappShareUrl(event = {}, url = eventCanonicalUrl(event)) {
  return `https://wa.me/?text=${encodeURIComponent(
    [eventShareText(event), url].filter(Boolean).join("\n")
  )}`;
}

export function facebookShareUrl(event = {}, url = eventCanonicalUrl(event)) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

export function getEventPageMetadata(event = {}) {
  const item = normalizeEventRecord(event);
  const canonicalUrl = eventCanonicalUrl(item);
  const date = formatEventDateLabel(item);
  const location = eventLocationText(item);
  const description = truncate(
    item.seoDescription ||
      [item.description, date, location].filter(Boolean).join(" · "),
    200
  );
  const image = item.flyerUrl && getEventMediaKind(item) === "image"
    ? item.flyerUrl
    : DEFAULT_SHARE_IMAGE;

  return {
    title: tidyText(item.seoTitle) || `${item.title} | Urban Unity Network`,
    description: description || `View details for ${item.title}.`,
    canonicalUrl,
    image,
    type: "article",
  };
}
